export default "__VITE_ASSET__Dgmc3lg5__"